import Link from 'antd/es/typography/Link';

import { MaxMessengerLogo } from '@app/assets';
import TelegramLogo from '@app/components/LayoutLogin/icons/TelegramLogo.svg';
import VKLogo from '@app/components/LayoutLogin/icons/VKLogo.svg';
import WhatsAppLogo from '@app/components/LayoutLogin/icons/WhatsAppLogo.svg';

import type { FC } from 'react';

export const LogoSpace: FC = () => (
  <div className="LogoSpace">
    <Link
      href="https://wa.me/79802100010"
      target="_blank"
      rel="noopener noreferrer"
      className="LogoSpace__link"
    >
      <img src={WhatsAppLogo} alt="WhatsApp" />
    </Link>
    <Link
      href="https://t.me/Byhelp_poddergka"
      target="_blank"
      rel="noopener noreferrer"
      className="LogoSpace__link"
    >
      <img src={TelegramLogo} alt="Telegram" />
    </Link>
    <Link
      href="https://vk.com/byhelpcrm"
      target="_blank"
      rel="noopener noreferrer"
      className="LogoSpace__link"
    >
      <img src={VKLogo} alt="ВКонтакте" />
    </Link>
    <Link
      href="https://max.ru/u/f9LHodD0cOImzkxuDOyWacqev4-GiYPI_Ckt2mfFDqfb3k8NNak6lYE_Udw"
      target="_blank"
      rel="noopener noreferrer"
      className="LogoSpace__link"
    >
      <img src={MaxMessengerLogo} alt="MAX" />
    </Link>
  </div>
);
